import api from 'api';
import type { UserPropertiesPreviouslyUsedValues } from 'redux/modules/accounts.types';
import type {
  AccountUserProperty,
  ClientSideAccountUserProperty,
  UserAccountProperty,
} from 'types/account';

const ACCOUNT_USER_PROPERTIES_ENDPOINT = 'account_user_properties.json';

export const AccountUserPropertiesApi = {
  get(): Promise<Array<AccountUserProperty>> {
    return api.get(ACCOUNT_USER_PROPERTIES_ENDPOINT);
  },
  save(
    accountUserProperties: Array<Omit<ClientSideAccountUserProperty, '_clientSideId'>>
  ): Promise<Array<AccountUserProperty>> {
    if (accountUserProperties.length === 0) return Promise.resolve([]);
    return api.post(ACCOUNT_USER_PROPERTIES_ENDPOINT, {
      account_user_properties: accountUserProperties,
    });
  },
};

const USER_ACCOUNT_PROPERTIES_ENDPOINT = 'user_account_properties';

export const UserAccountPropertiesApi = {
  get(userId: number): Promise<Array<UserAccountProperty & { _destroy?: 'true' }>> {
    return api.get(`${USER_ACCOUNT_PROPERTIES_ENDPOINT}/${userId}`);
  },
  getPreviouslyUsedValues(): Promise<UserPropertiesPreviouslyUsedValues> {
    return api.get(`${USER_ACCOUNT_PROPERTIES_ENDPOINT}/uniq_values`);
  },
  save(userId: number, accountUserProperties: Array<any>): Promise<void> {
    if (accountUserProperties.length === 0) return Promise.resolve();
    return api.put(`${USER_ACCOUNT_PROPERTIES_ENDPOINT}/${userId}`, {
      user_account_properties: accountUserProperties,
    });
  },
};
